var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 1.00016C0.5 0.631973 0.798477 0.333496 1.16667 0.333496H7.16667C7.53486 0.333496 7.83333 0.631973 7.83333 1.00016C7.83333 1.36835 7.53486 1.66683 7.16667 1.66683H1.16667C0.798477 1.66683 0.5 1.36835 0.5 1.00016ZM10.5 0.333496C10.8682 0.333496 11.1667 0.631973 11.1667 1.00016V7.39069L12.0286 6.52876C12.2889 6.26841 12.7111 6.26841 12.9714 6.52876C13.2318 6.78911 13.2318 7.21122 12.9714 7.47157L10.9714 9.47157C10.7111 9.73192 10.2889 9.73192 10.0286 9.47157L8.0286 7.47157C7.76825 7.21122 7.76825 6.78911 8.0286 6.52876C8.28895 6.26841 8.71106 6.26841 8.97141 6.52876L9.83333 7.39069V1.00016C9.83333 0.631973 10.1318 0.333496 10.5 0.333496ZM0.5 5.00016C0.5 4.63197 0.798477 4.3335 1.16667 4.3335H5.83333C6.20152 4.3335 6.5 4.63197 6.5 5.00016C6.5 5.36835 6.20152 5.66683 5.83333 5.66683H1.16667C0.798477 5.66683 0.5 5.36835 0.5 5.00016ZM0.5 9.00016C0.5 8.63197 0.798477 8.3335 1.16667 8.3335H5.83333C6.20152 8.3335 6.5 8.63197 6.5 9.00016C6.5 9.36835 6.20152 9.66683 5.83333 9.66683H1.16667C0.798477 9.66683 0.5 9.36835 0.5 9.00016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescending);
export default __webpack_public_path__ + "static/media/descending.9dff7fa3dcf9f477ccdd73e377ddc80a.svg";
export { ForwardRef as ReactComponent };